module.exports = __webpack_public_path__ + "img/stratup-brand-logo-5.af5daa2f.png";